import React from "react";

export default function Facltywhyshould() {
  const cards = [
    {
      number: "01",
      title: "Increase facility visibility",
      desc: "Make your facility discoverable to innovators, startups, industries, researchers and government organisations.",
    },
    {
      number: "02",
      title: "Receive relevant project opportunities",
      desc: "Get access to prototype and manufacturing RFQs matching your registered capabilities.",
    },
    {
      number: "03",
      title: "Improve machine utilisation",
      desc: "Identify idle or underutilised machines and increase their productive usage.",
    },
    {
      number: "04",
      title: "Build your digital presence",
      desc: "Create a professional profile with machines, certifications, photos, videos and portfolio.",
    },
    {
      number: "05",
      title: "Manage projects digitally",
      desc: "Handle RFQs, quotations, work orders, teams and payments from one platform.",
    },
    {
      number: "06",
      title: "Build long-term customer relationships",
      desc: "Develop relationships and convert prototype projects into repeat business.",
    },
  ];

  return (
    <>
      <ResponsiveStyles />
      <section className="why-register-section" style={styles.section}>
        <div className="why-register-wrap" style={styles.wrap}>
          <div style={styles.header}>
            <h2 className="why-register-heading" style={styles.heading}>
              Why should your facility join <br />
              <span style={styles.accent}>APIC ProtoHub?</span>
            </h2>
            <p className="why-register-sub" style={styles.subheading}>
              Join India's leading prototyping & manufacturing network
            </p>
          </div>

          <div className="why-register-grid" style={styles.grid}>
            {cards.map((card, index) => (
              <div key={index} className="why-register-card" style={styles.card}>
                <div className="why-register-number-wrapper" style={styles.numberWrapper}>
                  <span className="why-register-number" style={styles.number}>
                    {card.number}
                  </span>
                </div>
                <h3 className="why-register-title" style={styles.cardTitle}>
                  {card.title}
                </h3>
                <p className="why-register-desc" style={styles.cardDesc}>
                  {card.desc}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}

/**
 * Responsive rules injected via a real <style> tag (rendered with the
 * component, not appended to document.head manually — this way it works
 * the same in SSR, avoids duplicate-tag bugs, and cleans up automatically
 * with the component).
 *
 * Mobile uses a column stack (flex-direction: column) instead of a grid,
 * since a single-column grid can behave inconsistently with parent width
 * constraints — a flex column is more predictable for stacking cards.
 */
function ResponsiveStyles() {
  return (
    <style>{`
      /* ---------- Tablet ---------- */
      @media (max-width: 1024px) {
        .why-register-grid {
          grid-template-columns: repeat(2, 1fr) !important;
          gap: 20px !important;
        }
      }

      /* ---------- Mobile: switch to column stack ---------- */
      @media (max-width: 700px) {
        .why-register-grid {
          display: flex !important;
          flex-direction: column !important;
          grid-template-columns: none !important;
          gap: 18px !important;
        }
        .why-register-card {
          width: 100% !important;
          box-sizing: border-box !important;
          padding: 26px 22px !important;
        }
        .why-register-number-wrapper {
          width: 44px !important;
          height: 44px !important;
        }
        .why-register-number {
          font-size: 1rem !important;
        }
        .why-register-title {
          font-size: 1rem !important;
        }
        .why-register-desc {
          font-size: 0.92rem !important;
        }
        .why-register-heading {
          font-size: 1.8rem !important;
        }
        .why-register-sub {
          font-size: 1rem !important;
          padding: 0 8px !important;
        }
        .why-register-wrap {
          padding: 0 18px !important;
        }
      }

      /* ---------- Small phones ---------- */
      @media (max-width: 480px) {
        .why-register-grid {
          gap: 14px !important;
        }
        .why-register-card {
          padding: 20px 18px !important;
          border-radius: 14px !important;
        }
        .why-register-number-wrapper {
          width: 40px !important;
          height: 40px !important;
          border-radius: 12px !important;
          margin-bottom: 16px !important;
        }
        .why-register-number {
          font-size: 0.9rem !important;
        }
        .why-register-title {
          font-size: 0.95rem !important;
        }
        .why-register-desc {
          font-size: 0.88rem !important;
          margin-top: 6px !important;
        }
        .why-register-heading {
          font-size: 1.5rem !important;
        }
        .why-register-sub {
          font-size: 0.92rem !important;
        }
        .why-register-section {
          padding: 40px 0 !important;
          min-height: auto !important;
        }
      }
    `}</style>
  );
}

const styles = {
  section: {
    width: "100%",
    minHeight: "100vh",
    display: "flex",
    alignItems: "center",
    background: "linear-gradient(180deg, #f4f7fc 0%, #eef1f8 100%)",
    fontFamily: "'Inter', 'Segoe UI', sans-serif",
    boxSizing: "border-box",
    padding: "30px 0",
  },
  wrap: {
    width: "100%",
    maxWidth: 1280,
    margin: "0 auto",
    padding: "0 32px",
    textAlign: "center",
    boxSizing: "border-box",
  },
  header: {
    textAlign: "center",
    marginBottom: 48,
  },
  heading: {
    fontFamily: "'Sora', 'Segoe UI', sans-serif",
    fontWeight: 800,
    fontSize: "clamp(2rem, 3.6vw, 3.1rem)",
    letterSpacing: "-0.02em",
    color: "#0b1330",
    margin: 0,
    lineHeight: 1.2,
  },
  accent: {
    color: "#f7941d",
  },
  subheading: {
    marginTop: 12,
    fontSize: "1.08rem",
    lineHeight: 1.7,
    color: "#5a6280",
    maxWidth: 600,
    marginLeft: "auto",
    marginRight: "auto",
  },
  grid: {
    marginTop: 40,
    display: "grid",
    gridTemplateColumns: "repeat(3, 1fr)",
    gap: 24,
    textAlign: "left",
  },
  card: {
    background: "#ffffff",
    border: "1px solid #e7eaf3",
    borderRadius: 18,
    padding: "32px 28px 30px",
    boxShadow: "0 20px 40px -30px rgba(11,19,48,0.12)",
    transition: "transform 0.25s ease, box-shadow 0.25s ease",
    position: "relative",
    boxSizing: "border-box",
  },
  numberWrapper: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: 48,
    height: 48,
    borderRadius: 14,
    background: "#0b1330",
    marginBottom: 22,
  },
  number: {
    fontFamily: "'Sora', 'Segoe UI', sans-serif",
    fontWeight: 700,
    fontSize: "1.2rem",
    color: "#ffffff",
    letterSpacing: "-0.02em",
  },
  cardTitle: {
    fontFamily: "'Sora', 'Segoe UI', sans-serif",
    fontWeight: 700,
    fontSize: "1.08rem",
    color: "#0b1330",
    margin: 0,
    lineHeight: 1.3,
  },
  cardDesc: {
    marginTop: 10,
    fontSize: "0.95rem",
    lineHeight: 1.6,
    color: "#6b7290",
  },
};